import {IconButton} from "@mui/material";
import {Close} from "@mui/icons-material";
import {Branch} from "./types.ts";

/**
 *
 * @param branch
 * @param onClose
 * @constructor
 */
export const BranchHint = ({ branch, setShowHint }: { branch: Branch, setShowHint: (show: boolean) => void }) => {
    return (
        <div className="branch-info-hint">
            <strong style={{fontSize: 17,}}>Пункт выдачи</strong>
            <IconButton style={{float: 'right',}} onClick={() => setShowHint(false)}><Close /></IconButton>
            <div style={{marginTop: 6}}>{branch.address}</div>
            <div style={{display: 'inline-block',marginTop: 10,marginBottom: 10,minHeight: 200,}}>
                {branch.images.map((image, key) => {
                    return (
                        <div key={`branch-image-${key}`} style={{maxWidth: '50%',padding: 3,display: 'inline-block',}}>
                            <a href={image} data-lightbox={"image-" + branch.id}>
                                <img style={{borderRadius: 3,}} src={image} />
                            </a>
                        </div>
                    )}
                )}
            </div>
            <div style={{marginBottom: 10}}>
                <div style={{display: 'flex'}}>
                    <div style={{width: '30%'}}>Расписание</div>
                    <div style={{width: '60%',marginLeft: 5,color: '#6c6c6c',wordBreak: 'break-all',}}>{branch.schedule}</div>
                </div>
            </div>
            <div style={{display: 'flex',}}>
                <div style={{width: '30%'}}>Варианты оплаты</div>
                <div style={{width: '60%',marginLeft: 5,color: '#6c6c6c'}}>
                    <div>Банковской картой на сайте</div>
                    <div>СБП на сайте</div>
                    {branch.paymentTypes.map((paymentType, key) => {
                        return (<div key={`branch-payment-type-${key}`}>{paymentType} в ПВ</div>);
                    })}
                </div>
            </div>
        </div>
    );
};
